<template>
  <div v-if="obj">
    <el-drawer visible="visible" direction="ttb" :with-header="false" size="100%">
      <!-- <van-popup v-model="visible" position="top" class="HideScrollbar"> -->
      <div class="main">
        <!-- <van-nav-bar fixed placeholder> </van-nav-bar> -->
        <!-- {{ bkmenu }} -->
        <!-- {{ obj }} -->
        <h3>
          <el-button class="back" type="text" icon="el-icon-back" @click="onCancel" />
          {{ obj.id }}
        </h3>
        <!-- <pre>{{ obj }}</pre> -->
        <el-form ref="form" :model="obj" label-width="120px">
          <el-form-item label="* 類別名稱">
            <el-input v-model="obj.id" placeholder="類別名稱 (唯一不可重覆)"></el-input>
          </el-form-item>
          <el-form-item label="描述說明">
            <el-input v-model="obj.text" placeholder="描述說明"></el-input>
          </el-form-item>
          <el-form-item label="大類別圖片">
            <ImagePicker
              :r="{ label: '', value: obj.imgfile }"
              @pick="obj.imgfile = $event"
            />
          </el-form-item>
          <el-form-item label="可售星期">
            <!-- {{ saleWeek }} -->
            <el-checkbox-group v-model="saleWeek" fill="#eee">
              <el-checkbox v-for="r in week" :label="r" :key="r">
                {{ weekDscp[r] }}
                <!-- <i class="el-icon-close" style="font-size:1rem"/> -->
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="指定時段">
            <el-input
              maxlength="9"
              v-model="saleTime"
              placeholder="9碼 mmss-mmss"
            ></el-input>
          </el-form-item>

          <el-form-item label="POS ONLY">
            <el-switch v-model="obj.posOnly" />
            <!-- <el-checkbox v-model="obj.posOnly">备选项</el-checkbox> -->
          </el-form-item>
          <el-form-item label="選擇餐點">
            <el-select
              v-model="options"
              multiple
              filterable
              default-first-option
              placeholder="請選擇"
            >
              <el-option
                v-for="item in bkmenu.menuitem"
                :key="item.TypeNo + item.ItemName"
                :label="getLabel(item)"
                :value="JSON.stringify(item)"
              >
              </el-option>
            </el-select>
            <el-button @click="addOptions()">加入</el-button>

            <el-table :data="obj.options" stripe style="width: 100%" empty-text="empty">
              <el-table-column
                prop="TypeNo"
                label="類別編號"
                width="100"
              ></el-table-column>
              <el-table-column prop="ItemName" label="名稱"></el-table-column>
              <el-table-column prop="ItemCode" label="代碼" width="100"></el-table-column>
              <el-table-column align="right" width="80">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="danger"
                    icon="el-icon-delete"
                    @click="handleDelete(scope.$index)"
                  />
                </template>
              </el-table-column>
              <el-table-column align="right" width="100">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    icon="el-icon-top"
                    circle
                    @click="cmdUp(scope.$index, scope.row)"
                  />
                  <el-button
                    size="mini"
                    icon="el-icon-bottom"
                    circle
                    @click="cmdDown(scope.$index, scope.row)"
                  />
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>

          <el-form-item>
            <el-button @click="onOk">儲存</el-button>
            <el-button @click="onDelete">刪除</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- </van-popup> -->
    </el-drawer>
  </div>
</template>

<style scoped>
.back {
  font-size: 2rem;
}
.van-popup {
  width: 100%;
  height: 100%;
}
.main {
  font-size: 1.6rem;
  /* line-height: 4rem; */
  padding: 1rem;
  text-align: left;
}
</style>

<script>
export default {
  data() {
    return {
      visible: false,
      obj: null,
      objString: "",
      bkmenu: null,
      options: [],
      saleWeek: [0, 1, 2, 3, 4, 5, 6],
      week: [0, 1, 2, 3, 4, 5, 6],
      weekDscp: ["日", "一", "二", "三", "四", "五", "六"],
      saleTime: "",
    };
  },
  methods: {
    cmdUp(index, row) {
      if (index < 1) {
        return;
      }
      // var exttype = this.bkmenu.exttype;
      var options = this.obj.options;
      options.splice(index, 1);
      options.splice(index - 1, 0, row);
    },
    cmdDown(index, row) {
      // var exttype = this.bkmenu.exttype;

      var options = this.obj.options;
      if (index > options.length - 2) {
        return;
      }
      options.splice(index, 1);
      options.splice(index + 1, 0, row);
    },
    async init() {
      try {
        var res = await this.apiGetBKMenu();
        this.bkmenu = res.data;
        this.options = [];
      } catch (error) {
        console.log(error.toString());
      }
    },
    async showCreate() {
      await this.init();
      this.obj = {
        id: "",
        text: "",
        type: "",
        limit: 1,
        lock: true,
        remark: "",
        options: [],
        saleWeek: [0, 1, 2, 3, 4, 5, 6],
        saleTime: "",
      };
      this.visible = true;
    },
    async showEdit(rowIndex, obj) {
      if (!Object.hasOwn(obj, "imgfile")) obj.imgfile = "";
      this.saleTime = "";
      this.saleWeek = [0, 1, 2, 3, 4, 5, 6];
      await this.init();
      console.log("show", rowIndex);
      this.objString = JSON.stringify(obj);
      this.obj = JSON.parse(this.objString);
      this.obj.saleWeek && (this.saleWeek = this.obj.saleWeek);
      this.obj.saleTime && (this.saleTime = this.obj.saleTime);

      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    getLabel(row) {
      var output = [];
      output.push(row.TypeNo);
      output.push(row.ItemName);
      output.push("$" + row.Price1);
      output.push(row.ItemCode);
      return output.join(" , ");
    },
    addOptions() {
      this.options.forEach((r) => {
        let row = {};
        r = JSON.parse(r);
        row.TypeNo = r.TypeNo;
        row.ItemName = r.ItemName;
        row.KPtype = r.KPtype;
        row.ItemCode = r.ItemCode;
        row.Price1 = r.Price1;

        this.obj.options.push(row);
      });
      this.options = [];
    },
    onCancel() {
      // this.obj = JSON.parse(this.objString);
      // console.log("string", this.objString);
      // console.log("objobj", JSON.stringify(this.obj));
      this.obj = null;
      this.visible = false;
    },
    async onOk() {
      // this.obj = JSON.parse(this.objString);
      // console.log("string",this.objString);
      // console.log("objobj",JSON.stringify(this.obj));
      this.saleWeek.sort();
      this.obj.saleWeek = this.saleWeek;
      this.obj.saleTime = this.saleTime;

      console.log("saleTime", this.saleTime);
      var body = { item: this.obj };
      console.log("body", body);
      var res = await this.apiUpdateExttype(body);
      var key = res.data.key;
      console.log("ok.key", key);
      this.visible = false;
      this.obj = null;
      this.$emit("ok");
    },
    async onDelete() {
      this.gSure("確認刪除").then(async () => {
        var body = { key: this.obj.key };
        var res = await this.apiDeleteExttype(body);
        console.log(res.data);
        this.visible = false;
        this.$emit("ok");
      });
    },
    async handleDelete(rowIndex) {
      this.obj.options.splice(rowIndex, 1);
      // console.log(index, row);
      // this.obj.options.splice(index, 1);
      // var body = { key: row.key };
      // var res = await this.apiDeleteExttype(body);
      // console.log(index, res);
    },
  },
};
</script>
